import {Component, OnInit, Inject, AfterViewInit, ViewChildren} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {DigitalCertificateService} from 'src/app/core/services/digital-certificate.service';
import {UserService} from 'src/app/core/services/user.service';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {Message} from '../../../../../../core/class/message';
import FileUtils, {ContentType} from '../../../../../../core/services/file-utils';
// @ts-ignore
import {NzUploadFile} from 'ng-zorro-antd/upload';
import {Observable, Observer, Subscription} from 'rxjs';
import {DomSanitizer} from '@angular/platform-browser';
import {WarningComponent} from '../../../../../../shared/components/warning/warning.component';
import {MatDialog} from '@angular/material/dialog';
import {CommonService} from '../../../../../../core/services/common.service';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-edit-digital-certificate',
  templateUrl: './edit-digital-certificate.component.html',
  styleUrls: ['./edit-digital-certificate.component.scss'],
})
export class EditDigitalCertificateComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = [
    'stt',
    'userNameManager',
    'action'
  ];
  options: string[];
  isDeleted:boolean = false
  syncCertDetail:any = {}
  constructor(
    private digitalCertificateService: DigitalCertificateService,
    public dialogRef: MatDialogRef<EditDigitalCertificateComponent>,
    private usService: UserService,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastr: ToastrService,
    public message: Message,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private commonService: CommonService,
  ) {
    dialogRef.disableClose = true;
    this.id = data.id;
    this.idDetail = data.idDetail;
    this.isSync = data.isSync;
    this.syncCertDetail = data.syncCertDetail || {}
  }

  id = null;
  idDetail = null;
  isSync = false;
  certificate = {
    id: null,
    idDetail: null,
    enterpriseId: null,
    enterpriseName: '',
    serialNumber: '',
    serialNumberNew: '',
    taxCode: '',
    activeDate: '',
    expireDate: '',
    isDeleted: false,
    phoneNumber: '',
    typeCertificate: 0,
    typeCertificateInText: '',
    filePath: '',
    issuedTo: '',
    issuedBy: '',
    imagePath: '',
    lstIdNameDTO: [],
    activeDateNew: '',
    expireDateNew:  '',
    providerName: '',
    cloudCaUsername: '',
    lstUserIdManagement: []
  };
  private isDisable: boolean;
  private fileUpload: File;
  private imageUrl: string | ArrayBuffer;
  private stampDivWrapper: HTMLElement;
  private stampSign: HTMLElement;
  private file: File;
  public success: boolean;
  public isFormChanging = false;

  @ViewChildren('focus') focus;
  fileName: any;
  infoMessage: any;
  progress: any;
  isUploading: any;
  public avatarUrl?: string;
  public loading = false;
  previewVisible = false;
  wrongFileFormat = false;
  fileTooLarge = false;
  inputUserValue: string;
  filteredUserOptions = [];
  nzCheckLoadingUser = false;
  isProcess = false;
  /**
   * Init component
   */
  ngOnInit() {
    if (this.isSync) {
      this.getSyncCertDetail(this.syncCertDetail);
      return;
    }
    this.getCertificateById(this.id, this.idDetail);
  }

  deleteCertificate(username) {
    this.isFormChanging = true;
    this.certificate.lstIdNameDTO = this.certificate.lstIdNameDTO.filter(v => v.id !== username.id);
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focus.first.nativeElement.focus(), 500);
  }

  // private _filter(value: string): string[] {
  //   // const filterValue = value.toLowerCase();
  //   // // console.log(this.options.filter(option => option.toLowerCase().includes(filterValue)));
  //   // return this.options ? this.options.filter(option => option.toLowerCase().includes(filterValue)) : null;
  //
  //
  //   if (value) {
  //     this.digitalCertificateService.getUserNameAndFullName(value).subscribe((rs: any) => {
  //       if (rs) {
  //         this.options = rs.map(value1 => value1.name);
  //       }
  //       console.log(this.options.filter(option => option.toLowerCase().includes(value.toLowerCase())));
  //       setTimeout(() => {
  //         return this.options ? this.options.filter(option => option.toLowerCase().includes(value.toLowerCase())) : null;
  //       }, 1500);
  //       // console.log(this.options)
  //       // return this.options.filter(option => option['name'].toLowerCase().includes(value.toLowerCase()))[0];
  //     });
  //   }
  // }

  private getBase64(img: File, callback: (img: string) => void): void {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result!.toString()));
    reader.readAsDataURL(img);
  }

  handleChange(info: { file: NzUploadFile }): void {
    this.isFormChanging = true;
    this.wrongFileFormat = false;
    this.fileTooLarge = false;
    switch (info.file.status) {
      case 'uploading':
        this.loading = true;
        break;
      case 'done':
        // Get this url from response in real world.
        this.getBase64(info.file!.originFileObj!, (img: string) => {
          this.loading = false;
          // this.fileUpload = info.file;
          this.avatarUrl = img;
        });
        break;
      case 'error':
        this.toastr.error('Network error');
        this.loading = false;
        break;
    }
  }

  dummyRequest = ({file, onSuccess, onError}) => {
    this.fileUpload = file;
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  }

  beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]) => {
    return new Observable((observer: Observer<boolean>) => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.wrongFileFormat = true;
        this.fileTooLarge = false;
        // this.toastr.error(this.message.getMessage('messages.only_accept_png_jpg'));
        observer.complete();
        return;
      }
      const isLt2M = file.size! / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.wrongFileFormat = false;
        this.fileTooLarge = true;
        // this.toastr.error(this.message.getMessage('messages.image_must_than_5m'));
        observer.complete();
        return;
      }
      observer.next(isJpgOrPng && isLt2M);
      observer.complete();
    });
  }

  /**
   * Get certificate by Id certificate
   */
  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  handlePreview = async (file: NzUploadFile) => {
    this.previewVisible = true;
  }
  getSyncCertDetail(cert) {
    if (!cert) {
      return
    }
    this.certificate = cert;
    const {imagePath} = cert;
    if (imagePath) {
      const imageDataBlob = this.commonService.b64toBlob(imagePath);
      const blobUrl = URL.createObjectURL(imageDataBlob);
      this.avatarUrl = blobUrl;
      this.fileUpload =  new File([imageDataBlob], 'certificate.png', { type: 'image/png' });
    }
    // translate type certificate
    switch (this.certificate.typeCertificate) {
      case 0: {
        this.translate
          .get('digital_certificate_management.cbx_certificate_type.cbx_server')
          .subscribe(s => (this.certificate.typeCertificateInText = s));
        break;
      }
      case 1: {
        this.translate
          .get('digital_certificate_management.cbx_certificate_type.cbx_usb')
          .subscribe(s => (this.certificate.typeCertificateInText = s));
        break;
      }
      case 2: {
        this.translate
          .get('digital_certificate_management.cbx_certificate_type.cbx_sim_ca')
          .subscribe(s => (this.certificate.typeCertificateInText = s));
        break;
      }
      case 3: {
        this.translate
          .get('digital_certificate_management.cbx_certificate_type.cbx_otp')
          .subscribe(s => (this.certificate.typeCertificateInText = s));
        break;
      }
      case 4: {
        this.translate
          .get('digital_certificate_management.cbx_certificate_type.cbx_hsm')
          .subscribe(s => (this.certificate.typeCertificateInText = s));
        break;
      }
      case 10: {
        this.translate
        .get('digital_certificate_management.cbx_certificate_type.cbx_cloud_ca')
        .subscribe(s => (this.certificate.typeCertificateInText = s));
      break;
      }
      case 11: {
        this.translate
          .get('digital_certificate_management.cbx_certificate_type.cbx_easy_ca')
          .subscribe(s => (this.certificate.typeCertificateInText = s));
        break;
      }
      case 12: {
        this.translate
          .get('digital_certificate_management.cbx_certificate_type.cbx_vneid')
          .subscribe(s => (this.certificate.typeCertificateInText = s));
        break;
      }
    }
  }
  getCertificateById(id: string, idDetail: string) {
    this.digitalCertificateService.viewDigitalCertificateDetail(id, idDetail).subscribe(rs => {
      this.certificate = rs.data;
      const {imagePath} = this.certificate;
      if (this.isSync) {
        this.certificate.activeDateNew = this.syncCertDetail.activeDateNew || '';
        this.certificate.expireDateNew = this.syncCertDetail.expireDateNew || '';
      }
      if (imagePath) {
        const imageDataBlob = this.commonService.b64toBlob(imagePath);
        const blobUrl = URL.createObjectURL(imageDataBlob);
        this.avatarUrl = blobUrl;
        // this.previewVisible = true;
      }
      // translate type certificate
      switch (this.certificate.typeCertificate) {
        case 0: {
          this.translate
            .get('digital_certificate_management.cbx_certificate_type.cbx_server')
            .subscribe(s => (this.certificate.typeCertificateInText = s));
          break;
        }
        case 1: {
          this.translate
            .get('digital_certificate_management.cbx_certificate_type.cbx_usb')
            .subscribe(s => (this.certificate.typeCertificateInText = s));
          break;
        }
        case 2: {
          this.translate
            .get('digital_certificate_management.cbx_certificate_type.cbx_sim_ca')
            .subscribe(s => (this.certificate.typeCertificateInText = s));
          break;
        }
        case 3: {
          this.translate
            .get('digital_certificate_management.cbx_certificate_type.cbx_otp')
            .subscribe(s => (this.certificate.typeCertificateInText = s));
          break;
        }
        case 4: {
          this.translate
            .get('digital_certificate_management.cbx_certificate_type.cbx_hsm')
            .subscribe(s => (this.certificate.typeCertificateInText = s));
          break;
        }
        case 10: {
          this.translate
          .get('digital_certificate_management.cbx_certificate_type.cbx_cloud_ca')
          .subscribe(s => (this.certificate.typeCertificateInText = s));
        break;
        }
        case 11: {
          this.translate
            .get('digital_certificate_management.cbx_certificate_type.cbx_easy_ca')
            .subscribe(s => (this.certificate.typeCertificateInText = s));
          break;
        }
        case 12: {
          this.translate
            .get('digital_certificate_management.cbx_certificate_type.cbx_vneid')
            .subscribe(s => (this.certificate.typeCertificateInText = s));
          break;
        }
      }
    });
  }

  /**
   * Close dialog view certificate
   */
  onClose() {
    this.dialogRef.close();
  }

  onUpdateCertificateImage() {
    const lstUserIdManagement = this.certificate.lstIdNameDTO.map(cert => {
      return cert.id;
    });
    const data = {
      ...this.certificate,
      image: this.fileUpload,
      digitalCertificateId: this.certificate.id,
      digitalCertificateDetailId: this.idDetail,
      lstIdNameDTO: this.certificate.lstIdNameDTO,
      lstUserIdManagement
    };

    if (this.isSync) {
      this.onSyncClouCa(data);
      return;
    }

    if(this.fileUpload == null && this.isDeleted == true){
      delete data.imagePath;
      delete data.image;
    }

    this.digitalCertificateService.updateListUserManager(data).subscribe(rs => {
      this.toastr.success(this.message.getMessage('messages.update_success'));
      this.success = true;
      this.dialogRef.close();
    });

    // if (this.fileUpload) {
      this.digitalCertificateService.updateImageCertificateBase64(data).then(rs => {
        this.success = true;
        this.dialogRef.close();
      });
    }
  // }

  onSelectFile(Event) {
    if (typeof (FileReader) !== 'undefined') {
      let file: File;
      file = Event.target.files[0];
      if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
        if (!this.toastr.findDuplicate(this.message.getMessage('messages.only_accept_pdf'), true, true)) {
          this.toastr.error(this.message.getMessage('messages.only_accept_pdf'));
          this.isDisable = true;
        }
      } else {
        if (file.size <= 10485760) {
          this.checkContentTypeThenAddFile(file);
        } else {
          if (!this.toastr.findDuplicate(this.message.getMessage('validation.file'), true, true)) {
            this.toastr.error(this.message.getMessage('validation.file'));
            this.isDisable = true;
          }
        }
      }
    }
  }

  private checkContentTypeThenAddFile(file: File) {
    FileUtils.getContentType(file)
      .then((contentType) => {
        if (ContentType.PNG === contentType || ContentType.BMP === contentType || ContentType.JPEG === contentType) {
          this.fileUpload = file;
          this.imageUrl = URL.createObjectURL(file);
          const reader = new FileReader();
          const image = document.getElementById('#imagePreview');
          if (image) {
            image.setAttribute('src', URL.createObjectURL(file));
          }
          // tslint:disable-next-line:max-line-length
          const imageStamp = `<img src="${URL.createObjectURL(file)}" style="height: ${this.stampDivWrapper.style.height.replace('px', '')}px;"/>`;
          this.stampDivWrapper.innerHTML = imageStamp;
          this.stampSign.setAttribute('src', URL.createObjectURL(file));
        } else {
          this.toastr.error(this.message.getMessage('messages.only_accept_pdf'));
          this.isDisable = true;

        }
      }).catch((err) => {
      this.toastr.error(this.message.getMessage('messages.only_accept_pdf'));
      this.isDisable = true;

    });
  }

  onChange(file: File) {
    if (file) {
      this.fileName = file.name;
      this.file = file;

      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = event => {
        this.imageUrl = reader.result;
      };
    }
  }

  onUpload() {
    this.infoMessage = null;
    this.progress = 0;
    this.isUploading = true;
  }

  onCancel() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        } else {
          dialogRe.close();
        }
      });
    } else {
      this.dialogRef.close();
    }
  }

  onChangeUserSignSearch(event): void {
    if (this.inputUserValue.trim().length > 0) {
      this.nzCheckLoadingUser = true;
      this.digitalCertificateService.getUserNameAndFullName(this.inputUserValue.trim())
        .subscribe(result => {
          this.filteredUserOptions = result.data;
          this.nzCheckLoadingUser = false;
        }, error => {
          this.nzCheckLoadingUser = false;
        });
    } else {
      this.inputUserValue = '';
      this.filteredUserOptions = [];
    }
  }

  autocompleteUserSelected($event: any, model: any) {
    if ($event.isUserInput) {
      if (this.certificate.lstIdNameDTO && this.certificate.lstIdNameDTO.length > 4) {
        this.toastr.error(this.message.getMessage('messages.error_signing_method_manager_5'));
        return false;
      }
      this.isFormChanging = true;
      const duplicateItem = this.certificate.lstIdNameDTO.find(item => item.id === model.id);
      if (!duplicateItem || duplicateItem.length === 0) {
        this.certificate.lstIdNameDTO.push(model);
      }
    }
  }

  confirmDelete(){
        this.isFormChanging = true;
        this.avatarUrl = '';
        this.fileUpload = null
        this.isDeleted = true
  }

  /**
   * Process upload file when select type upload is Select file .cer or .cert
   */

  processUpload(tempDigitalCertificate) {
   const data = tempDigitalCertificate;
    if (this.fileUpload) {
      this.digitalCertificateService.uploadFileImageBase64(this.fileUpload).then(rs => {
        data.digitalCertificateDetail[0].imagePath = rs.data;
        data.filePath = rs.data;
        this.onSaveSyncData(data);
      });
    }
  }
  onSyncClouCa(data) {
    if (this.isProcess) {
      return;
    }

    this.isProcess = true;

    const tempDigitalCertificate = {
      "enterpriseId": data.enterpriseId,
      "typeCertificate": data.typeCertificate, // 10
      "phoneNumber": data.phoneNumber || '',
      "filePath": data.filePath || "",// path cua anh
      "fileName": data.fileName || "", // ten anh
      "lstUserIdManagement": data.lstUserIdManagement || [],
      "digitalCertificateDetail": data.digitalCertificateDetail,
      "providerName": data.providerName || '',
      "providerId": data.providerId || '',
      "cloudCaUsername": data.cloudCaUsername || '',
      "credentialId": data.credentialId || '',
  };
    if(tempDigitalCertificate.digitalCertificateDetail && tempDigitalCertificate.digitalCertificateDetail.length > 0) {
      tempDigitalCertificate.digitalCertificateDetail[0].expireDate = new Date(tempDigitalCertificate.digitalCertificateDetail[0].expireDate);
      tempDigitalCertificate.digitalCertificateDetail[0].activeDate = new Date(tempDigitalCertificate.digitalCertificateDetail[0].activeDate);
      tempDigitalCertificate.credentialId = tempDigitalCertificate.digitalCertificateDetail[0].credentialId;
    }
    const dialogRe = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.commonService.format(this.message.getMessage('certificate.note2'), [`${data.cloudCaUsername || data.certificateName} (${data.serialNumber})`])
    });
    dialogRe.afterClosed().subscribe(rs => {
      if (rs) {
        if(this.fileUpload){
          this.processUpload(tempDigitalCertificate);
          return;
        }
        this.onSaveSyncData(tempDigitalCertificate);
      }
      dialogRe.close();
    });

  }

  onSaveSyncData(tempDigitalCertificate) {
    this.digitalCertificateService.add(tempDigitalCertificate).subscribe(rs => {
      this.isProcess = false;
      if (rs.success) {
        this.toastr.success(this.message.getMessage('certificate.sync_success'));
        this.success = true;
        this.dialogRef.close(true);
      } else {
        this.toastr.error(rs.message);
        this.isProcess = false;
      }
    });
  }
}

